var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSortAmountDownSolid = function SvgSortAmountDownSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5v2h12V5Zm17 0v18.688l-2.594-2.594L17 22.5l4.281 4.313.719.687.719-.687L27 22.5l-1.406-1.406L23 23.687V5ZM4 9v2h10V9Zm0 4v2h8v-2Zm0 4v2h6v-2Zm0 4v2h4v-2Zm0 4v2h2v-2Z"
  })));
};
export default SvgSortAmountDownSolid;